module.exports = __webpack_public_path__ + "img/tn-timeline-main-19.c51cd2bc.jpg";